module.exports = __webpack_public_path__ + "img/instagram-icon.9d9c5aee.svg";